import { IFluidObject } from '@fluidframework/core-interfaces';
import { NotificationService } from '@fluidx/office-fluid-types';
import { PostMessageSender, PostMessageHandlerFactory } from '../Shared/PostMessage';
import { NotifyAtMentionCalledMessage, NotifyAtMentionReturnedMessage, PairingValue } from '../MessageTypes';
import { deserializeError, serializeError } from '@fluidx/utilities';

export function getHostSideNotificationService(
  scope: IFluidObject
): {
  scopePairingValue?: PairingValue<Promise<NotificationService>>;
  scopeHandler?: PostMessageHandlerFactory;
} {
  const notificationService = scope.NotificationServicePromise;
  if (!notificationService) {
    return {};
  }

  return {
    scopePairingValue: { found: true },
    scopeHandler: (sender: PostMessageSender) => {
      return {
        ['NotifyAtMentionCalled']: async (message) => {
          if (message.payload) {
            const { recipientUpn, contentId, navigationPath } = (message as NotifyAtMentionCalledMessage).payload;
            let reply: NotifyAtMentionReturnedMessage;
            try {
              const result = await (await notificationService).notifyAtMention(recipientUpn, contentId, navigationPath);
              reply = {
                payload: { result }
              };
            } catch (e: any) {
              reply = {
                error: true,
                payload: serializeError(e)
              };
            }

            sender.sendReply(message, reply);
          }
        }
      };
    }
  };
}

export function getGuestSideNotificationService(sender: PostMessageSender): Promise<NotificationService> {
  const NotificationServicePromise: Promise<NotificationService> = Promise.resolve({
    get NotificationService(): Promise<NotificationService> {
      return Promise.resolve(this);
    },
    notifyAtMention(recipientUpn: string, contentId: string, navigationPath: string): Promise<boolean> {
      const message: NotifyAtMentionCalledMessage = {
        type: 'NotifyAtMentionCalled',
        payload: { recipientUpn, contentId, navigationPath }
      };
      return sender.sendWithReturn(message).then((reply) => {
        const payload = (reply as NotifyAtMentionReturnedMessage).payload;

        if (typeof payload !== 'string') {
          return Promise.resolve(payload.result);
        }

        if (reply.error) {
          return Promise.reject(deserializeError(payload));
        }

        return Promise.resolve(false);
      });
    }
  });

  return NotificationServicePromise;
}

// cspell:ignore iframed
